module.exports = __webpack_public_path__ + "img/edge_divers_top20.d8b3ac7b.svg";